var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.1988 11.0002H2.79883V5.4002C2.79883 4.28629 3.24133 3.218 4.02898 2.43035C4.81663 1.64269 5.88492 1.2002 6.99883 1.2002C8.11274 1.2002 9.18102 1.64269 9.96868 2.43035C10.7563 3.218 11.1988 4.28629 11.1988 5.4002V11.0002Z",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.29883 13.7988H7.69883",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.699219 10.999H13.2992",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBell;